var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoGeneralitatValenciana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 494.1 236.3",
    style: {
      enableBackground: "new 0 0 494.1 236.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#C80F2E;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M142.2,110.3c6.7,0,11-1.9,15-5.5v-13h-15.9v4.9H152v5.7c-2.5,2-5.8,3-9.9,3c-8.2,0-14.1-6-14.1-14.2 c0-8.1,5.8-14.2,13.5-14.2c6.5,0,9.1,2.9,11,5.1l3.8-3.5c-3.4-3.9-7.7-6.5-14.7-6.5c-10.7,0-19,8.4-19,19.1 C122.7,102,131.1,110.3,142.2,110.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M319.8,71.9l-15.7,38h5.4l3.1-7.6h16l3.1,7.6h5.4l-15.7-38H319.8z M314.6,97.3l6-14.7l6,14.7H314.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M414.8,109.9l3.1-7.6h16l3.1,7.6h5.4l-15.7-38H425l-15.7,38H414.8z M425.9,82.6L425.9,82.6l6,14.7h-12 L425.9,82.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "204.6,83.3 228.4,110.4 230.1,110.4 230.1,72.4 225,72.4 225,99 201.2,71.9 199.5,71.9 199.5,109.9 204.6,109.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "171.7,96.6 187.8,96.6 187.8,91.8 171.7,91.8 171.7,77.3 189.7,77.3 189.7,72.4 166.4,72.4 166.4,109.9 190.5,109.9 190.5,105 171.7,105  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "395.5,109.9 400.8,109.9 400.8,77.3 411.7,77.3 411.7,72.4 384.4,72.4 384.4,77.3 395.5,77.3  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372.2,
    y: 72.4,
    className: "st0",
    width: 5.3,
    height: 37.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "264.6,105 245.8,105 245.8,96.6 262,96.6 262,91.8 245.8,91.8 245.8,77.3 263.9,77.3 263.9,72.4 240.6,72.4 240.6,109.9 264.6,109.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "365.3,105 348.7,105 348.7,72.4 343.5,72.4 343.5,109.9 365.3,109.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "440,72.4 440,77.3 451.1,77.3 451.1,109.9 456.4,109.9 456.4,77.3 467.8,77.3 467.8,72.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M291.4,98c5.1-2.2,7.8-6.4,7.8-12c0-8.5-5.8-13.6-15.6-13.6h-9.9v37.5h5.3V99.5h4.6c1,0,1.7,0,2.5-0.1l7,10.5 h6.4L291.4,98z M283.4,94.7H279V77.3h4.4c7,0,10.4,2.8,10.4,8.7C293.8,91.8,290.4,94.7,283.4,94.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "415.4,153.3 391.6,126.2 389.9,126.2 389.9,164.1 395,164.1 395,137.5 418.8,164.6 420.5,164.6 420.5,126.7 415.4,126.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M315.1,159.6c-7.9,0-13.7-6-13.7-14.2c0-8.1,5.8-14.2,13.5-14.2c5.5,0,8.8,2.5,11.2,5.8l4.1-3 c-3.2-4.5-8.1-7.8-15.3-7.8c-10.8,0-18.9,8.2-18.9,19.1c0,10.9,8.1,19.2,19,19.2c7.6,0,12.7-3.3,16.2-8.3l-4.2-3 C324.4,157,320.7,159.6,315.1,159.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M172.3,126.2l-15.7,38h5.4l3.1-7.6h16l3.1,7.6h5.4l-15.7-38H172.3z M167.1,151.6l6-14.7l6,14.7H167.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "153.5,126.7 142.7,153.6 131.9,126.7 126.2,126.7 141.9,164.6 143.5,164.6 159.2,126.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M366.3,126.2l-15.7,38h5.4l3.1-7.6h16l3.1,7.6h5.4l-15.7-38H366.3z M361.1,151.6l6-14.7l6,14.7H361.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M442.5,126.2l-15.7,38h5.4l3.1-7.6h16l3.1,7.6h5.4l-15.7-38H442.5z M437.3,151.6l6-14.7l6,14.7H437.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "283.3,153.3 259.4,126.2 257.8,126.2 257.8,164.1 262.8,164.1 262.8,137.5 286.7,164.6 288.3,164.6 288.3,126.7 283.3,126.7  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.9,
    y: 126.7,
    className: "st0",
    width: 5.3,
    height: 37.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "229.9,150.9 246,150.9 246,146 229.9,146 229.9,131.6 248,131.6 248,126.7 224.6,126.7 224.6,164.1 248.7,164.1 248.7,159.2 229.9,159.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "201.2,126.7 195.9,126.7 195.9,164.1 217.7,164.1 217.7,159.2 201.2,159.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.3,57.7c3.3-4.8,3.8-4.9,3.8-4.9s-3.1-1-5,1.9c-3.3,4.8-3.8,4.9-3.8,4.9S38.4,60.5,40.3,57.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.3,176.2l18,18c7.5,7.5,16.7,12.3,26.4,14.5l-38.4-38.4L26.3,176.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.5,165l45,45c3.6,0,7.3-0.3,10.8-1l-49.9-49.9L37.5,165z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "75.8,93.6 72.6,93.6 72.6,97.4 68.8,97.4 68.8,100.7 72.6,100.7 72.6,104.5 73.7,104.5 73.7,109.4 74.7,109.4 74.7,104.5 75.8,104.5 75.8,100.7 79.7,100.7 79.7,97.4 75.8,97.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.9,142.5l38.4,38.4c-2.2-9.7-7-18.9-14.5-26.3l-18-18L59.9,142.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.7,153.8l49.9,49.9c0.7-3.6,1-7.2,1-10.8l-45-45L48.7,153.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 53.7,
    cy: 37.9,
    r: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.2,71.2L36.2,71.2l5.6,13.6l-7,14.2c0,0,5.3,10.6,7,20.1c1.6,9.2,0.3,23.4,0.3,23.4l26.2-13.2l0,0 c1.1,1.8,2.5,3.6,4.2,5.3c4.4,4.4,5.9,5.9,5.9,5.9l20.4-20.3l-1.3-1.3c-8.2-7.7-11.7-14.9-11.7-24.2v-9.9l5.5-13.6l0,0 c1-0.4,1.7-1.4,1.7-2.5c0-1.5-1.2-2.7-2.7-2.7s-2.7,1.2-2.7,2.7c0,0.7,0.2,1.3,0.6,1.7c-0.8,2.3-2.7,4.1-5.1,4.7 c-1.2-3.2-1.1-7,0.5-10.3c1.5-3,4.1-5.2,7-6.3c-1.9-2.4-3-5.6-2.7-9s1.8-6.3,4.1-8.4c-1.5-0.3-6.2-1-11.2,1.9 c-2.8-2.1-4.6-5.4-4.6-9.2c0-0.8,0.1-1.7,0.3-2.5c-1.3,0.5-2.6,0.8-4.1,0.8c-4.1,0-7.7-2.4-9.5-5.8l0,0c-1.6,2.5-4.5,4.2-7.7,4.2 s-6-1.7-7.6-4.2c0.7,7.5-1.6,16.4-8,21.1l1.7,2.3c1-0.8,2.1-1.7,3-2.6c0.4-0.4,0.8-0.7,1.3-0.6c0.8,0,1.5,0.7,1.5,1.5 c0,0.4-0.1,0.7-0.3,0.9l0,0c-0.4,0.9-0.7,1.9-0.7,3c0,1,0.2,2,0.6,2.9l2.6-1.2c-1.2-2.6,0.9-5.1,4.2-7.6c2.4-1.8,4.9-3.4,6.7-3.4 c2,0,3.7,1.7,3.7,3.7c0,2.3-2.3,4.1-4,5.2c-6.6,4.1-13.2,7.2-16.2,14.4c-1.3,3.1-1.7,6.2-1.8,8c-1.7-1.1-2.6-2.8-3-3.8 c0.4-0.5,0.6-1.1,0.6-1.7c0-1.5-1.2-2.7-2.7-2.7s-2.7,1.2-2.7,2.7C34.4,69.9,35.1,70.9,36.2,71.2z M55,132.4l-9.3,4.7 c0.2-5.1,0.3-12.7-0.7-18.5c-1.2-6.7-4.1-13.9-5.8-17.9h15.9L55,132.4L55,132.4z M58.2,130.8V97.4h-19l5.9-12h17.6v9.3 c0,2.8,0,8.6,0.4,14.7s1.2,11.8,3.7,17.1L58.2,130.8z M94.1,120.2l-15.7,15.7l-3.6-3.6c-6.1-6.1-7.8-13.7-8.4-23.1 c-0.3-4.4-0.4-9.1-0.4-14.5v-9.3h5.8h10.7l0,0v9.3C82.4,104.5,86,112.3,94.1,120.2z M46.6,67.7c3-7.6,12.6-11.4,17-14.5 c1.2-0.9,3.7-3.3,3.6-6.6c-0.1-3.7-3-6.7-6.7-6.7c-3.5,0-8.7,4-10.9,6.3c-0.7-1.1-1.4-1.6-2.5-2c2.2-3.8,3-7.3,3.6-11.3 c1.5,0.6,3.1,1,4.7,1c2.8,0,5.4-0.9,7.4-2.5c2.5,2.5,6,4.1,9.8,4.1c0.3,0,0.6,0,0.9,0c0.4,3.9,2.2,7.3,5,9.7h-0.4 c-1.4,1.2-2.8,2.7-4.1,4.7c-2.9,4.2-5.9,6.3-7.9,7.3c-1.8,0.9-3.2,1.2-3.6,1.2c0.2,1.1,0.3,2.1,0.3,3.2c0,2-0.4,3.9-1.1,5.7 l2.8,1.1c0.8-2.1,1.3-4.4,1.3-6.8c0-0.3,0-0.5,0-0.8c2.8-1.1,6.9-3.6,10.8-9.2c3.2-4.6,6.7-6.5,9.5-7.1c-0.6,1.5-1.1,3.2-1.2,4.9 c-0.2,2.9,0.3,5.6,1.5,8c-2.2,1.5-4.1,3.5-5.4,6.1c-1.9,3.8-2.2,8.1-1,11.9c-2.7-0.4-4.9-2.2-5.8-4.7c0.5-0.5,0.9-1.2,0.9-2 c0-1.5-1.2-2.7-2.7-2.7s-2.7,1.2-2.7,2.7c0,0.8,0.3,1.5,0.9,2c-1.1,2.8-3.8,4.8-7,4.8s-5.9-2-7-4.8c0.5-0.5,0.9-1.2,0.9-2 c0-1.5-1.2-2.7-2.7-2.7c-1.5,0-2.7,1.2-2.7,2.7c0,0.8,0.3,1.5,0.9,2c-1.1,2.8-3.8,4.8-7,4.8c-0.4,0-0.7,0-1-0.1 C45.1,74.1,45.3,70.8,46.6,67.7z M46.2,78.5c3.7,0,6.9-1.9,8.8-4.7c1.9,2.9,5.1,4.7,8.8,4.7c3.7,0,6.9-1.9,8.8-4.7 c1.9,2.9,5.1,4.7,8.8,4.7c1.5,0,2.8-0.3,4.1-0.8l-2,4.5H43.9L42,77.7C43.3,78.2,44.7,78.5,46.2,78.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGeneralitatValenciana);
export default __webpack_public_path__ + "static/media/logo-generalitat-valenciana.8d1e5bb37e3679f819cd07e3cf4406c7.svg";
export { ForwardRef as ReactComponent };